import tinycolor from "tinycolor2"

/** @deprecated */
export const TREND_COLOR_SET = {
  positive: "#1AFFAC",
  negative: "#FF5E1A",
}

/** A list of all color palette colors as variables. */

/** @deprecated */
export const COLORS_LARGE_SET = Object.values({
  "$tt-chart-color-1": "hsl(var(--chart-1))",
  "$tt-chart-color-2": "hsl(var(--chart-2))",
  "$tt-chart-color-3": "hsl(var(--chart-3))",
  "$tt-chart-color-4": "hsl(var(--chart-4))",
  "$tt-chart-color-5": "hsl(var(--chart-5))",
  "$tt-chart-color-6": "hsl(var(--chart-6))",
  "$tt-chart-color-7": "hsl(var(--chart-7))",
  "$tt-chart-color-8": "hsl(var(--chart-8))",
  "$tt-chart-color-9": "hsl(var(--chart-9))",
  "$tt-chart-color-10": "hsl(var(--chart-10))",
  "$tt-chart-color-12": "hsl(var(--chart-12))",
  "$tt-chart-color-13": "hsl(var(--chart-13))",
  "$tt-chart-color-14": "hsl(var(--chart-14))",
  "$tt-chart-color-15": "hsl(var(--chart-15))",
  "$tt-chart-color-16": "hsl(var(--chart-16))",
  "$tt-chart-color-17": "hsl(var(--chart-17))",
  "$tt-chart-color-18": "hsl(var(--chart-18))",
  "$tt-chart-color-19": "hsl(var(--chart-19))",
  "$tt-chart-color-20": "hsl(var(--chart-20))",
  "$tt-chart-color-21": "hsl(var(--chart-21))",
})

/** @deprecated */
export const getColors = (length: number) => {
  return COLORS_LARGE_SET.slice(0, length)
}

/** @deprecated */
export const getComputedVariableColor = (color: string) => {
  if (color.startsWith("var(")) {
    return getComputedStyle(document.body).getPropertyValue(
      color.replace("var(", "").replace(")", "")
    )
  } else if (color.startsWith("hsl(")) {
    const innerVariable = color.replace("hsl(", "").replace(")", "")
    const computedVariable = getComputedStyle(document.body).getPropertyValue(
      innerVariable.replace("var(", "").replace(")", "")
    )
    const parsedHSL = tinycolor(`hsl(${computedVariable})`)
    return parsedHSL.toHexString()
  }

  return color
}
